/** Idle time before showing the session warning modal (30 minutes). */
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

/** Countdown duration after the warning appears (60 seconds). */
export const WARNING_DURATION_SEC = 120;

/** How often each tab updates its heartbeat in the tab registry. */
export const TAB_HEARTBEAT_MS = 2000;

/** Tabs without a heartbeat within this window are treated as closed. */
export const TAB_STALE_MS = 5000;

/** BroadcastChannel name for cross-tab session events. */
export const SESSION_CHANNEL_NAME = 'kisangrow_admin_session';
